module.exports = __webpack_public_path__ + "static/media/news1_2.37655377.jpeg";